import { SET_STORED_SALESPERSON_NAMES } from "../action.js";
import { getSalesPersonNames } from "../api/api";

export function fetchSalesPersonNames(dealerAccountID, parentDealerID, createByUser) {
  return (dispatch) => {
    return getSalesPersonNames(dealerAccountID, parentDealerID, createByUser).then((data) => {
      dispatch({ type: SET_STORED_SALESPERSON_NAMES, payload: data });
    });
  };
}
